
<div class="settings-item !items-start">
    <div class="setting-wrapper">
        <div class="heading-wrapper">
            <div class="description">
                <div class="settings-header">
                    <div class="with-label">
                        Inventory Locations
                        <app-badge [color]="BadgeColorsEnum.Green">beta</app-badge>
                    </div>
                </div>
                <div class="flex flex-row">
                    <div class="settings-sub-header">
                        Distribute your inventory across different locations
                    </div>
                </div>
    
            </div>
        </div>
        <div class="controls">
            <div class="switch" *ngIf="!(inventoryLocationsEnabled$ | async)"
                (click)="onEnableInventoryLocationsClick()" >
                <img class="toggle-switch" [class.hidden]="(inventoryLocationsEnabled$ | async)" src="assets/icons/icon-slide-switch-is-off.svg"
                    alt="off" title="off" />
            </div>
            <app-button *ngIf="(inventoryLocationsEnabled$ | async)"
                class="add-new" 
                styleClass="settings" subStyle="blue" [minWidth]="0"
                (clicked)="addNew()">
                Add New
            </app-button>
        </div>
    </div>
    
    <div class="tabs" *ngIf="(inventoryLocationsEnabled$ | async)">
        <app-tabs (tabSelected)="tabWIChanged($event)" [tabsMarginLeft]="'32px'">
            <app-tab [tabValue]="InventoryLocationStatusEnum.Active"
                     [count]="activeInventoryLocationList?.length"
                     [tabTitle]="'Active'"
                     [active]="currentWITab === InventoryLocationStatusEnum.Active"
            >
                <app-inventory-locations-table *ngIf="activeInventoryLocationList?.length"
                    [inventoryLocationList]="activeInventoryLocationList"
                    (editLocation)="editLocation($event)"
                >
                </app-inventory-locations-table>
            </app-tab>
  
            <app-tab [tabValue]="InventoryLocationStatusEnum.Inactive"
                     [count]="inactiveInventoryLocationList?.length"
                     [tabTitle]="'Inactive'"
                     [active]="currentWITab === InventoryLocationStatusEnum.Inactive"
            >
                <app-inventory-locations-table *ngIf="inactiveInventoryLocationList?.length"
                    [inventoryLocationList]="inactiveInventoryLocationList"
                    (editLocation)="editLocation($event)"
                >
                </app-inventory-locations-table>
            </app-tab>
          </app-tabs>
       
    </div>
    
</div>

<app-add-edit-inventory-location-dialog *ngIf="displayAddEditLocationDialog$ | async"
    [data]="updateLocationData"
    (cancel)="displayAddEditLocationDialog$.next(false)"
    (save)="openSaveLocationPinDialog($event)"
></app-add-edit-inventory-location-dialog>

